/* RESPONSIBLE TEAM: team-fin-qa */
// Bridge route for QA all-reviews React view
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAiAgentAnalyzeMonitorReviewsRoute extends Route {
  queryParams = {
    page: { refreshModel: false },
    perPage: { refreshModel: false },
    reviewStatus: { refreshModel: false },
    reviewerId: { refreshModel: false },
    revieweeId: { refreshModel: false },
    filterMonitorId: { refreshModel: false },
    scorecardId: { refreshModel: false },
    sortBy: { refreshModel: false },
  };

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor.reviews',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAiAgentAnalyzeMonitorReviewsRoute, {
  overrideRenderTemplate: false,
});
